import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Centered spinner + optional label. Shared loading indicator — currently the
 * food-log tabs (Meals / Logs v1 / v3) use it while meals load.
 */
export const LoadingState = ({
  label,
  className,
}: {
  label?: string;
  className?: string;
}) => (
  <div
    role="status"
    aria-live="polite"
    className={cn(
      'flex flex-col items-center justify-center gap-2 py-12 text-sm text-muted-foreground',
      className,
    )}
  >
    <Loader2 className="h-6 w-6 animate-spin text-primary" />
    {label && <span>{label}</span>}
  </div>
);

/**
 * Full-viewport centered loading indicator. Used by route guards while
 * identity/role resolves and by lazy route boundaries while a chunk loads —
 * i.e. wherever the whole page has nothing to show yet (above any layout).
 */
export const FullPageLoading = ({ label }: { label?: string }) => (
  <div className="flex min-h-screen items-center justify-center p-6">
    <LoadingState label={label} />
  </div>
);
